/**************************************************
 * Nombre:       Barra
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid2} from "@mui/material";
import BarraPc from "./BarraPc";
import BarraCell from "./BarraCell";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";

const Barra = () => {
    const {masSM} = useResponsive()

    return (
        <Grid2
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
        >
            {masSM ?
                <BarraPc/>
                :
                <BarraCell/>
            }
        </Grid2>
    )

}
export default Barra